module.exports = __webpack_public_path__ + "static/media/privacypolicy-page-banner-1.c8f94da9.jpg";